import { createSlice } from '@reduxjs/toolkit';

// Initial state
const initialState = {
  token: null,
  userId: null,
  invite_type: null,
  org_id:null,
  loginuserdata:null,
  logindata:{},
  isAuthenticated: false,
  selectedApplication: 'MISSION-EXPLORER', 
};

// Create a slice of the state
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken(state, action) {
      state.token = action.payload.token;
      state.userId = action.payload.userId;
      state.org_id = action.payload.org_id;
      state.loginuserdata = action.payload.loginuserdata;
      state.invite_type = action.payload.invite_type;
      state.isAuthenticated = true; // Set to true when token is set
      state.logindata=action.payload.logindata
      
    },
    logout(state) {
      state.token = null;
      state.userId = null;
      state.org_id = null;
      state.invite_type = null;
      state.loginuserdata = null;
      state.isAuthenticated = false; // Set to false on logout
      state.logindata={};
      
    },
    setSelectedApplication(state, action) {
      state.selectedApplication = action.payload;
    },
  },
});

// console.log(authSlice.payload)
export const { setToken, logout ,setSelectedApplication} = authSlice.actions;
export default authSlice.reducer;
